module.exports = __webpack_public_path__ + "img/tanker_rader.dbe8ea30.png";